const i18n = require('i18n');
import ACTIVITY_JOG_SOLID from '@ifit/react-icons/dist/icons/ACTIVITY_JOG_SOLID';
import WATCH_CONNECTED_LINE from '@ifit/react-icons/dist/icons/WATCH_CONNECTED_LINE';
import USER_ADD_SOLID from '@ifit/react-icons/dist/icons/USER_ADD_SOLID';
import WHISTLE_SOLID from '@ifit/react-icons/dist/icons/WHISTLE_SOLID';
import RESISTANCE_SOLID from '@ifit/react-icons/dist/icons/RESISTANCE_SOLID';
import EXERCISE_SOLID from '@ifit/react-icons/dist/icons/EXERCISE_SOLID';

export default [
  {
    icon: ACTIVITY_JOG_SOLID,
    title: i18n('Train Better').context('Tells the user they can train better.').toString(),
    content: i18n('The best trainers in the business will walk you through incredible workouts that are personalized to fit your goals and preferences.').context('Tells the user our trainers will help them make their goals.').toString()
  },
  {
    icon: WATCH_CONNECTED_LINE,
    title: i18n('Save Time').context('Tells the user they can train in their own time.').toString(),
    content: i18n('By combining strength, cardio, and a fast pace, you\'ll always have time to squeeze in a worthwhile workout.').context('Tells the user we can build workouts around their time.').toString()
  },
  {
    icon: USER_ADD_SOLID,
    title: i18n('Join Classes').context('Tells the user they can join online classes.').toString(),
    content: i18n('Meet virtually with other fitness enthusiasts as you join virtual studio workouts, right in the comfort of your own home.').context('The user can connect and exercise online with other exercisers.').toString()
  },
  {
    icon: WHISTLE_SOLID,
    title: i18n('Get Coached').context('Tells the user they can work with our trainers.').toString(),
    content: i18n('Your [fusion] comes with additional coaching on your phone for nutrition, activity, and sleep with the [ifit] mobile app.').args({ fusion: 'Fusion', ifit: 'iFIT Coach' }).context('Tells the user they can get coaching through the app on their phone.').toString()
  },
  {
    icon: RESISTANCE_SOLID,
    title: i18n('Stay Fluid').context('Tells the user they can work out easily.').toString(),
    content: i18n('With [smr] ([silent]), your flywheel provides smooth, quiet movement, so you\'ll never adjust another weight.').args({ smr: 'SMR™', silent: 'Silent Magnetic Resistance' }).context('Tells the user they can work out quietly without many adjustments.').toString()
  },
  {
    icon: EXERCISE_SOLID,
    title: i18n('Find Power').context('Tells the user they can build strength.').toString(),
    content: i18n('The easy-to-read watts meter gives you accurate readings throughout your workout, so you\'ll always know how much power you\'re producing.').context('Tells the user they can monitor with how much strength they are putting out.').toString()
  },
];
